export const isEmpty = (v: unknown): boolean => {
  if (v == null) return true
  // tslint:disable-next-line:triple-equals
  if ('boolean' == typeof v) return false
  // tslint:disable-next-line:triple-equals
  if ('number' == typeof v) return v === 0
  // tslint:disable-next-line:triple-equals
  if ('string' == typeof v) return v.trim().length === 0
  // tslint:disable-next-line:triple-equals
  if ('function' == typeof v) return v.length === 0
  if (Array.isArray(v)) return v.length === 0
  if (v instanceof Error) return isEmpty(v.message)
  if ('object' === typeof v) return Object.entries(v as Record<string, unknown>).length === 0

  return false
}

export const isNotEmpty = (v: unknown): boolean => !isEmpty(v)
